import { isTrue } from '@avantia/client-and-server-utilities';
import { HpClientStandardInputTextAndStyle } from '../../../types';
import { HpInputControlProps } from '../../../types/inputControlTypes';
import { StandardFormGroupWidget } from '../../widgets/standardFormGroupWidget';
import { BasicSwitchControl, HpBasicSwitchTypes, HpCreateSwitchButtonProps } from '../common/basicSwitchControl';
import { isDisabled } from '../common/tools';
import { CheckButton } from './buttonListControl';

export type HpSwitchControlProps = HpInputControlProps;

export function SwitchControl(props: HpSwitchControlProps): JSX.Element {
  return switchControlCommon(props, { type: 'switch' });
}

export function ButtonSwitchControl(props: HpSwitchControlProps): JSX.Element {
  return switchControlCommon(props, { type: 'button' });
}

export function CheckSwitchControl(props: HpSwitchControlProps): JSX.Element {
  const { disabled, name, pageProps, value } = props;

  return switchControlCommon(props, {
    type: 'button',
    createSwitchCustomButton: ({ onClick, itemId: itemKey, key, text }) => {
      const isSelected = isTrue(value as string | boolean);
      return CheckButton({
        controlProps: { name, disabled },
        onClick,
        itemKey,
        itemProps: {
          pageProps,
          lookupKey: itemKey,
          isSelected,
          optionText: text
        },
        key
      });
    }
  });
}

export function SaveEditButtonControl(props: HpSwitchControlProps): JSX.Element {
  return switchControlCommon(props, { type: 'save-button' });
}

interface HpCustomSwitchProps {
  createSwitchCustomButton?: (props: HpCreateSwitchButtonProps) => JSX.Element;
  type: HpBasicSwitchTypes;
}

function switchControlCommon(
  {
    id,
    value,
    answerSource,
    data,
    dataType,
    errors,
    formatType,
    question,
    ui,
    onClick,
    onChange,
    questionText,
    subtext
  }: HpSwitchControlProps,
  { type, createSwitchCustomButton }: HpCustomSwitchProps
): JSX.Element {
  const textAndStyle = data.textAndStyle[formatType] as HpClientStandardInputTextAndStyle;
  const error = errors ? errors[id] : undefined;
  const disabled = isDisabled(question, ui);

  const switchControl = (
    <BasicSwitchControl
      createSwitchCustomButton={createSwitchCustomButton}
      data={data.lookup}
      disabled={disabled}
      eventDetail={{ type: 'standard', question }}
      id={id}
      onClick={onClick}
      type={type}
      value={value as string}
    />
  );

  return (
    <StandardFormGroupWidget
      answerSource={answerSource}
      control={switchControl}
      controlType="switch"
      dataType={dataType}
      error={error}
      helpInfo={data.helpInfo}
      helpInfoUI={ui.helpInfo}
      id={id}
      onClick={onChange}
      question={question}
      questionText={questionText}
      subtext={subtext}
      textAndStyle={textAndStyle}
    />
  );
}
